import { Button, Stack, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { FileInfoProps as Props } from './types';

export const FileInfo = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper className={classnames('FileInfo', className)} sx={SX.root}>
      <Stack gap={1}>
        <Stack direction="row" gap={1} alignItems="center">
          <Icon name="file-outline" sxx={SX.fileIcon} />
          <Typography sx={SX.fileName}>warmleads-export.csv</Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button variant="outlined" color="primary" sx={SX.button}>
            <Icon name="eye-outlined" sxx={SX.icon} />
            View in Search
          </Button>
          <Button variant="outlined" color="primary" sx={SX.button}>
            <Icon name="download-vector" sxx={SX.icon} />
            Download
          </Button>
        </Stack>
      </Stack>
    </Styled.Wrapper>
  );
});

FileInfo.displayName = 'FileInfo';
